import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Input from '../../components/Input/Input';
import CountryCodeSelector from '../../components/CountryCodeSelector/CountryCodeSelector';
import Button from '../../components/Button/Button';
import Banner from '../../components/Banner/Banner';
import { validateForgotPasswordForm } from '../../utils/validations/formValidations';
import infinity from '../../assets/login/infinity.png';
import logo from '../../assets/logo.png';
import './ForgotPassword.css';
import Modal from '../../components/Modal/Modal';
// services
import { authService } from '../../services/login';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    code: '',
    phone: '',
    email: ''
  });
  const [errors, setErrors] = useState({
    code: '',
    phone: '',
    email: ''
  });

  const handleChange = (e, field) => {
    setFormData(prev => ({
      ...prev,
      [field]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const { errors, hasErrors } = validateForgotPasswordForm(formData);
    setErrors(errors);

    if (!hasErrors) {
      // Handle password recovery logic here
      console.log('Form is valid, sending code...');
      console.log('Form data:', formData);
      // Redireccionar a la página de verificación
      //navigate('/verify-code', { state: { formData } });
      try {
        const response = await authService.forgotPassword({ email: formData.email });
        console.log('Password recovery request sent:', response);
        if (response.data.status === 'success') {
          setIsModalOpen(true);
        }
      } catch (error) {
        console.error('Failed to send password recovery request:', error);
      }
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    navigate('/verify-code', { state: { formData } });
  };

  return (
    <div className="forgot-password-container">
      <div className="forgot-password-form-container">
        <img src={logo} alt="Barterflip Logo" className="logo" />
        <h1 className="title">
          FORGOT YOUR <span className="highlight">PASSWORD</span>
        </h1>
        <p className="subtitle">
          Enter the required information and you will receive your{' '}
          <span className="highlight">verification code</span> in an instant.
        </p>

        <form onSubmit={handleSubmit} className="forgot-password-form" noValidate>
          <div className="phone-input">
            <CountryCodeSelector
              selectedCode={formData.code}
              onSelect={(code) => handleChange({ target: { value: code }}, 'code')}
              error={errors.code}
            />
            <Input
              type="tel"
              placeholder="Phone number"
              value={formData.phone}
              onChange={(e) => handleChange(e, 'phone')}
              error={errors.phone}
              required
            />
          </div>
          <Input
            type="email"
            placeholder="Email"
            value={formData.email}
            onChange={(e) => handleChange(e, 'email')}
            error={errors.email}
            required
          />
          <Button type="submit" fullWidth>Send Code</Button>
        </form>
      </div>
      <Banner 
        image={infinity}
      />
      <Modal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        title={{ text: 'Password Recovery', highlight: 'Request' }}
        showConfirmButton={true}
        confirmText="Confirm"
        onConfirm={handleModalClose}
        message='A verification code has been sent to your phone number or email address.'
      />
    </div>
  );
};

export default ForgotPassword;
